import React, { useCallback, useState } from "react";
import classes from "./Layout.module.scss";
import { useSelector, useDispatch } from "react-redux";
import { funcClearOtpResponseOnEdit } from "../../../store/actions/OtpActions";
import Tabs from "../Tabs/Tabs";
import CommonView from "../CommonCardView/CommonView";
import SidePanel from "../SidePanel/SidePanel";
import MobileHeader from "../MobileViewHeader/MobileHeader";
import { getSection, trackPages } from "../../../shared/utility";
import { appNavigateTo } from '../../../store/actions/navActions';

export const Layout = (props) => {
  //const { state } = useLocation();
  const state = useSelector((state) => state.AppNav);
  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state.User.UserDetail);
  const clearOtpResponse = () => dispatch(funcClearOtpResponseOnEdit());

  const goTo = state && state.goTo ? state.goTo : "penydrop";

  const handleEdit = useCallback(() => {
    trackPages("tracking_22");
    clearOtpResponse();
    dispatch(appNavigateTo({ goTo: "personalDetails" }, 'APP_NAVIGATE_TO'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.goTo]);

  const sepmobile = props?.children?.props?.children?.props?.children?.props?.sepmobile;

  const [closePopup, setClosePopUp] = useState(false)

  const handlePopup = (value) => {
    setClosePopUp(value)
  };

  const checkForLeftPannel = () => {
    const path = goTo;
    return path === "KycDetails";
  };

  return (
    <>
      <div className={classes.FlexInner}>
        <div className={`${classes.CardDetails} 
                          ${getSection(goTo) === "personalDetails" ? classes.BackPersonalDetails : ""}
                          ${getSection(goTo) === "professionalDetails" ? classes.BackProfessionalDetails : ""}
                          ${getSection(goTo) === "kycDetails" ? classes.BackKYCDetails : ""}
                          `}>
          <div
            className={`${checkForLeftPannel()
              ? classes.withoutLeftPannelMainPage
              : classes.withLeftPannelMainPage
              }`}
          >
            <SidePanel getSection={getSection(goTo)} goTo={goTo} sepmobile={sepmobile} classes={classes} cardName={props?.cardName} userDetail={userDetail} />
            {!sepmobile && (
              <MobileHeader goTo={goTo} handlePopup={handlePopup} getSection={getSection(goTo)} classes={classes} />
            )}
            <div
              className={`${!sepmobile ? classes.DetailsCard : classes.LandingDetailsCard
                } ${checkForLeftPannel() ? classes.NoLeftPannel : ""}`}
            >
              <CommonView
                handleEdit={handleEdit}
                goTo={goTo}
                classes={classes}
                userDetail={userDetail}
                children={props.children}
                closePopup={closePopup}
                handleclosePopup={handlePopup}
                cardName={props?.cardName}
              />
              {!sepmobile && goTo !== "validateOTP" && (
                <Tabs userDetail={userDetail} getSection={getSection(goTo)} classes={classes} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
